<template>
    <ul class="badge-list">
        <slot />
    </ul>
</template>
